import { Observable, observe, Scope } from 'src/3rds/cube'

// :: Types (espelham apps/server/src/mensagem-direta/mensagem-direta.types.ts)

export type SituacaoRecado = 'pendente' | 'enviado' | 'entregue' | 'lido' | 'falhou' | 'cancelado'

export type Recado = {
    id: string
    ownerId: string
    parceiro: string
    telefone: string
    texto: string
    operador: string
    criadoEm: string
    situacao: SituacaoRecado
    enviadoEm?: string
    erro?: string
    avisoEm?: string
    avisoSituacao?: 'enviado' | 'entregue' | 'lido' | 'falhou'
    avisoErro?: string
    canceladoPor?: string
    canceladoEm?: string
}

export type Parceiro = {
    ownerId: string
    nome: string
    email: string
    telefone?: string
    ultimaMensagem?: string
    janelaAberta: boolean
    bloqueado: boolean
    pendentes: number
}

/** Uma mensagem da conversa do parceiro com a LIA (GET /api/chat/contacts/:id/messages). */
export type MensagemDaConversa = {
    id: string
    content: string
    timestamp: string
    /** true: o parceiro escreveu; false: a LIA respondeu. */
    sent: boolean
    status?: string
}

/** Limite do WhatsApp para texto; o servidor confere de novo. */
export const LIMITE_TEXTO = 4096

export const RECADOS_POR_PAGINA = 15

// :: Scopes

@Observable
export class MensagemDiretaScope extends Scope {
    @observe() busca = ''
    @observe() pagina = 0
    @observe() total = 0
    @observe() recados: Recado[] = []
    @observe() carregandoLista = false

    // Diálogo "Nova mensagem"
    @observe() novaAberta = false
    @observe() buscaParceiro = ''
    @observe() opcoesParceiro: Parceiro[] = []
    @observe() buscandoParceiros = false
    @observe() parceiro?: Parceiro
    @observe() texto = ''
    @observe() erroEnvio?: string
    @observe() enviando = false

    // Conversa do parceiro, como apoio (painel recolhível no diálogo)
    @observe() conversaAberta = false
    @observe() conversa: MensagemDaConversa[] = []
    @observe() carregandoConversa = false

    // Confirmação de cancelamento
    @observe() cancelarAberto?: Recado
    @observe() cancelando = false

    onAtualizar = Scope.ASYNC_ACTION
    onBuscaChange = Scope.ASYNC_ACTION_STRING
    onPaginaChange = Scope.ASYNC_ACTION_ONE<number>()

    onAbrirNova = Scope.ASYNC_ACTION_STRING
    onFecharNova = Scope.ASYNC_ACTION
    onBuscaParceiroChange = Scope.ASYNC_ACTION_STRING
    onParceiroChange = Scope.ASYNC_ACTION_ONE<Parceiro | null>()
    onTextoChange = Scope.ASYNC_ACTION_STRING
    onConversaToggle = Scope.ASYNC_ACTION
    onEnviar = Scope.ASYNC_ACTION

    onAbrirCancelar = Scope.ASYNC_ACTION_STRING
    onFecharCancelar = Scope.ASYNC_ACTION
    onConfirmarCancelar = Scope.ASYNC_ACTION
}
